var map = {
	"./10Ton-PickUp-gray.png": 17778,
	"./10Ton-PickUp-green.png": 39642,
	"./10Ton-PickUp-red.png": 29473,
	"./10Ton-PickUp-yellow.png": 53959,
	"./2Ton-PickUp-gray.png": 92960,
	"./2Ton-PickUp-green.png": 86279,
	"./2Ton-PickUp-red.png": 88213,
	"./2Ton-PickUp-yellow.png": 49429,
	"./3Ton-PickUp-gray.png": 73478,
	"./3Ton-PickUp-green.png": 65570,
	"./3Ton-PickUp-red.png": 47555,
	"./3Ton-PickUp-yellow.png": 50201,
	"./5Ton-PickUp-gray.png": 66496,
	"./5Ton-PickUp-green.png": 95217,
	"./5Ton-PickUp-red.png": 14158,
	"./5Ton-PickUp-yellow.png": 34036,
	"./Ambulance-gray.png": 21446,
	"./Ambulance-green.png": 57958,
	"./Ambulance-red.png": 76730,
	"./Ambulance-yellow.png": 38437,
	"./Boom-Loader-gray.png": 74150,
	"./Boom-Loader-green.png": 58177,
	"./Boom-Loader-red.png": 18743,
	"./Boom-Loader-yellow.png": 72449,
	"./Bulldozer-gray.png": 33771,
	"./Bulldozer-green.png": 90813,
	"./Bulldozer-red.png": 72612,
	"./Bulldozer-yellow.png": 80028,
	"./Canter-gray.png": 81708,
	"./Canter-green.png": 85299,
	"./Canter-red.png": 7498,
	"./Canter-yellow.png": 34880,
	"./Car-gray.png": 32356,
	"./Car-gray1.png": 26590,
	"./Car-green.png": 57663,
	"./Car-green1.png": 105,
	"./Car-red.png": 62220,
	"./Car-red1.png": 83493,
	"./Car-yellow.png": 16002,
	"./Car-yellow1.png": 65854,
	"./Coaster-Bus-gray.png": 37798,
	"./Coaster-Bus-green.png": 2847,
	"./Coaster-Bus-red.png": 18026,
	"./Coaster-Bus-yellow.png": 7091,
	"./Crane-gray.png": 76966,
	"./Crane-green.png": 13800,
	"./Crane-red.png": 48612,
	"./Crane-yellow.png": 13498,
	"./Dumper-gray.png": 37026,
	"./Dumper-green.png": 36965,
	"./Dumper-red.png": 41374,
	"./Dumper-yellow.png": 88364,
	"./Excavator-gray.png": 88972,
	"./Excavator-green.png": 88503,
	"./Excavator-red.png": 8604,
	"./Excavator-yellow.png": 26011,
	"./Forklif-gray.png": 17806,
	"./Forklif-green.png": 25209,
	"./Forklif-red.png": 50047,
	"./Forklif-yellow.png": 39913,
	"./Hiace-gray.png": 2621,
	"./Hiace-green.png": 8273,
	"./Hiace-red.png": 58411,
	"./Hiace-yellow.png": 59010,
	"./Hilux-gray.png": 15849,
	"./Hilux-green.png": 90508,
	"./Hilux-red.png": 82723,
	"./Hilux-yellow.png": 21106,
	"./JCB-gray.png": 85340,
	"./JCB-green.png": 17908,
	"./JCB-red.png": 52299,
	"./JCB-yellow.png": 45851,
	"./Mini-Bus-gray.png": 83822,
	"./Mini-Bus-green.png": 62325,
	"./Mini-Bus-red.png": 26569,
	"./Mini-Bus-yellow.png": 54385,
	"./Motorcycle-gray.png": 72418,
	"./Motorcycle-green.png": 88307,
	"./Motorcycle-red.png": 98272,
	"./Motorcycle-yellow.png": 15337,
	"./PickUp-gray.png": 5184,
	"./PickUp-green.png": 81352,
	"./PickUp-red.png": 46022,
	"./PickUp-yellow.png": 16343,
	"./Roller-gray.png": 3300,
	"./Roller-green.png": 64103,
	"./Roller-red.png": 32029,
	"./Roller-yellow.png": 75696,
	"./SUV-gray.png": 88530,
	"./SUV-green.png": 45484,
	"./SUV-red.png": 4692,
	"./SUV-yellow.png": 22719,
	"./SchoolBus-gray.png": 61488,
	"./SchoolBus-green.png": 34487,
	"./SchoolBus-red.png": 90679,
	"./SchoolBus-yellow.png": 14138,
	"./Tanker-gray.png": 47445,
	"./Tanker-green.png": 94121,
	"./Tanker-red.png": 48442,
	"./Tanker-yellow.png": 4218,
	"./Tourist-Bus-gray.png": 84950,
	"./Tourist-Bus-green.png": 92898,
	"./Tourist-Bus-red.png": 24902,
	"./Tourist-Bus-yellow.png": 3368,
	"./Truck-gray.png": 58186,
	"./Truck-green.png": 51762,
	"./Truck-red.png": 42099,
	"./Truck-yellow.png": 44651,
	"./Urvan-gray.png": 62522,
	"./Urvan-green.png": 34285,
	"./Urvan-red.png": 30283,
	"./Urvan-yellow.png": 26986,
	"./Van-gray.png": 80898,
	"./Van-green.png": 28987,
	"./Van-red.png": 53507,
	"./Van-yellow.png": 39461,
	"./car-icon-blue.png": 41982,
	"./default-gray.png": 46298,
	"./default-gray1.png": 44781,
	"./default-green.png": 78090,
	"./default-green1.png": 66963,
	"./default-red.png": 25600,
	"./default-red1.png": 57689,
	"./default-yellow.png": 85781,
	"./default-yellow1.png": 6928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42344;